export default __webpack_public_path__ + "static/media/Scepter of Ten Thousand Hells.792695b6.jpg";